import comp from "./CustomLoginButton";
export default comp;
